var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M36.8519 25.3656L36.8519 2.00005",
    stroke: "#FF6456",
    strokeWidth: 3.14602,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M25.3656 38.9757L2.00005 38.9757",
    stroke: "#FF6456",
    strokeWidth: 3.14602,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M27.4896 28.9052L4.83213 6.24766",
    stroke: "#FF6456",
    strokeWidth: 3.14602,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.e99cdb68a1227d731e9e06164cd23dea.svg";
export { ForwardRef as ReactComponent };